<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>In memory of Fred Olds, as well as those who came before and after him, who worked diligently to share and preserve the history of the Old North State.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?11c14a0e